var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconConsentConfirm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2004_1171",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C12.3135 21.0017 13.6143 20.7438 14.8278 20.2412C16.0413 19.7385 17.1435 19.001 18.071 18.071C19.001 17.1435 19.7385 16.0413 20.2412 14.8278C20.7438 13.6143 21.0017 12.3135 21 11C21.0017 9.68655 20.7438 8.3857 20.2411 7.17222C19.7385 5.95875 19.001 4.85656 18.071 3.92901C17.1435 2.99902 16.0413 2.26151 14.8278 1.75885C13.6143 1.25619 12.3135 0.998307 11 1.00001C9.68655 0.998334 8.3857 1.25623 7.17222 1.75889C5.95875 2.26154 4.85656 2.99904 3.92901 3.92901C2.99904 4.85656 2.26154 5.95875 1.75889 7.17222C1.25623 8.3857 0.998334 9.68655 1.00001 11C0.998307 12.3135 1.25619 13.6143 1.75885 14.8278C2.26151 16.0413 2.99902 17.1435 3.92901 18.071C4.85656 19.001 5.95875 19.7385 7.17222 20.2411C8.3857 20.7438 9.68655 21.0017 11 21Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L10 14L16 8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2004_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 -1H23V23H-1V-1Z",
    fill: "#242424"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConsentConfirm);
export default __webpack_public_path__ + "static/media/IconConsentConfirm.66ae7a1d11f445d4b1d08fe62e82bceb.svg";
export { ForwardRef as ReactComponent };